import { useDispatch, useSelector } from "react-redux";
import { sortBy } from "lodash";

import { formatMinutesToHHMM } from "../../../utils/date";

import { dutyAndOpportunityRoutesSelector } from "../../../reducers/matrixProfile/selectors";
import { onRouteCLick } from "../../../reducers/ownApp/thunkActions";

import { BaseSummaryPopover } from "../Base/BaseSummaryPopover";
import { BaseRouteCodeValueItem } from "../Base/BaseRouteCodeValueItem";

const OpportunityTimePopover = ({ open, anchorEl, onClose }) => {
  const dispatch = useDispatch();
  const dutyOpportunityRoutes = useSelector(dutyAndOpportunityRoutesSelector);

  const routeClick = (route) => {
    dispatch(onRouteCLick(route));
    onClose();
  };

  return (
    <BaseSummaryPopover
      id={"opportunityTimePopover"}
      title={"Opportunity Time"}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
    >
      {sortBy(dutyOpportunityRoutes?.opportunity || [], "routeCode").map(
        (route) => (
          <BaseRouteCodeValueItem
            key={route.routeCode}
            routeCode={route.routeCode}
            value={formatMinutesToHHMM(
              route?.routeOptimisation?.dutyDifference
            )}
            onRouteClick={() => routeClick(route)}
          />
        )
      )}
    </BaseSummaryPopover>
  );
};

export default OpportunityTimePopover;
